import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiConfig} from '../../../shared/services/api/config.api';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class PensionCalculatorSetupService {
  constructor(public httpClient: HttpClient) {}

  getDefaultSetupValues(val): any {
    const searchString = val;
    return this.httpClient.get(ApiConfig.baseURL + 'api/calculator/getdefault?setUp=' + searchString);
  }

  updateSetUpValues(body: Object): Observable<any> {
    // tslint:disable:max-line-length
    const requestOptionsHeader = new HttpHeaders();
    requestOptionsHeader.set('Content-Type', 'application/json;charset=UTF-8')
    requestOptionsHeader.set('Accept', 'application/json;charset=UTF-8')
    return this.httpClient.post(ApiConfig.baseURL + 'api/calculator/save', body, {headers: requestOptionsHeader}) // ...using post request
 }
}
